<template src="../template/exhibition.html"></template>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getCookie } from '../utils/cacheUtil'
import { startToWatchGps, sendGeoLocation } from '../utils/geolocationUtil'
import Vue from 'vue'

export default {
  name: 'exhibition',
  computed: {
    ...mapState(['PROJECT_ID', 'QR_CODE', 'USER_GENDER', 'USER_AGE_RANGE', 'SHOW_LOCAL_NAME']),
    ...mapGetters(['getProjectId', 'getQRCode', 'getUserGender', 'getUserAgeRange', 'getUserName', 'getShowLocalName'])
  },
  methods: {
    ...mapMutations(['setUserName', 'setShowLocalName']),
    submit () {
      this.setUserName(this.userName)
      this.$router.push('exhibition')
    },
    async getShowInfo () {
      try {
        await Vue.axios.get('https://api.y2services.com/v1/guide/info/' + this.getProjectId).then((response) => {
          const data = response.data
          if (!_.isNull(data)) {
            this.showDescription = data.showDescription
            this.showLocalName = data.showLocalName
            this.setShowLocalName(data.showLocalName)
            this.organizer = data.organizer
            this.visualIdentityImage = data.visualIdentityImage
            this.isVisualIdentityImageAvailable = true
          }
        })
          .catch((e) => {
            // // console.error(e)
          }).finally(() => {
            // console.error('final')
            if (!_.isNil(window.localStorage.getItem('CURRENT_GUIDE_ID'))) {
              window.location.href = '/#/project/' + window.localStorage.getItem('PROJECT_ID') + '/follow/' + window.localStorage.getItem('CURRENT_GUIDE_ID')
            } else {
              this.isStartToNavigateBtnAvailable = true
            }
          })
      } catch (e) {
        // console.error(e)
      }
    }
  },
  created: function () {
    this.getShowInfo()
    if (window.localStorage.getItem('gpsTimeID') !== null) {
      clearInterval(parseInt(window.localStorage.getItem('gpsTimeID')))
      window.localStorage.removeItem('gpsTimeID')
    }
    startToWatchGps()
    sendGeoLocation(this.getProjectId, this.getQRCode, 'Exhibition')
    const timeoutID = window.setInterval(
      () => {
        sendGeoLocation(this.getProjectId, this.getQRCode, 'Exhibition')
      }, 15000
    )
    window.localStorage.setItem('gpsTimeID', timeoutID)
    if (_.isNull(window.localStorage.getItem('PROJECT_ID')) || (_.isNull(window.localStorage.getItem('QR_CODE')) && (window.localStorage.getItem('PROJECT_ID') !== '822b5299-7d52-4520-ab0b-8d5a0c286298'))) {
      this.$swal({
        title: '找不到專案代碼與 QR Code',
        text: '系統將自動導至官網',
        type: 'error'
      }).then(function (result) {
        if (result.value) {
          window.location.href = window.localStorage.getItem('projectOfficialSite')
        }
      })
    } else {
      if (window.localStorage.getItem('PROJECT_ID') !== '822b5299-7d52-4520-ab0b-8d5a0c286298') {
        const timeoutID = window.setInterval(
          () => {
            if (getCookie('follow-session') === null) {
              window.clearInterval(timeoutID)
              window.localStorage.removeItem('PROJECT_ID')
              window.localStorage.removeItem('QR_CODE')
              this.$swal({
                title: '感謝您參與這次的活動，使用時間已經結束',
                text: '系統將自動導至官網',
                type: 'info'
              }).then(function (result) {
                if (result.value) {
                  window.location.href = window.localStorage.getItem('projectOfficialSite')
                }
              })
            }
          }, 1000
        )
      }
    }
  },
  data: function () {
    return {
      projectId: '',
      showDescription: '',
      showLocalName: '',
      organizer: '',
      visualIdentityImage: '',
      isVisualIdentityImageAvailable: false,
      isStartToNavigateBtnAvailable: false
    }
  },
  mounted () {
    this.projectId = this.getProjectId
  }
}
</script>
